var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("© CopyRight 2019 北京澎湃数据服务有限公司 京ICP备2024046608号-2")]),_c('p',[_vm._v("为了获得更好的用户体验，请使用最新版谷歌浏览器。")])])
}]

export { render, staticRenderFns }